import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const OrganizationsUIContext = createContext();

export function useOrganizationsUIContext() {
  return useContext(OrganizationsUIContext);
}

export function OrganizationsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    const query = input ? input.slice(1) : '';
    api
      .get(`/organizations?per_page=10&sort=start_date${query ? `&${query}` : ''}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return (
    <OrganizationsUIContext.Provider value={value}>{children}</OrganizationsUIContext.Provider>
  );
}
